export default "__VITE_ASSET__Bt7890yE__"